import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class HeroHandler {
	init() {
		const heroElement = document.getElementById('hero-homepage');
		if (!heroElement) return;
		
		const h1Element = heroElement.querySelector('h1[data-animate="text"]');
		if (!h1Element) return;
		
		const splitText = new SplitText(h1Element, {
			type: "lines",
			linesClass: "hero-line"
		});
		
		const lines = splitText.lines;
		if (lines.length > 0) {
			const lastLine = lines[lines.length - 1];
			lastLine.classList.add('text-primary-5');
		}
	}
}